import {
  getActivityAttributesWithFields,
  getLeadAttributeOptionsWithFields,
  getTaskAttributesWithFields,
} from '@repo/advanced-filters';

export const FORM_FIELD_SUPPORTED_ENTITIES = {
  leadAttribute: 'lead_attribute',
  activityAttribute: 'activity_attribute',
  taskAttribute: 'task_attribute',
} as const;

export type SupportedEntityValueType = (
  typeof FORM_FIELD_SUPPORTED_ENTITIES
)[keyof typeof FORM_FIELD_SUPPORTED_ENTITIES];

export const FORM_FIELD_SUPPORTED_ENTITY_CONFIG = {
  [FORM_FIELD_SUPPORTED_ENTITIES.leadAttribute]: {
    document: getLeadAttributeOptionsWithFields(['isDefault']),
  },
  [FORM_FIELD_SUPPORTED_ENTITIES.activityAttribute]: {
    document: getActivityAttributesWithFields(['isDefault']),
  },
  [FORM_FIELD_SUPPORTED_ENTITIES.taskAttribute]: {
    document: getTaskAttributesWithFields(['isDefault']),
  },
};
